import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Table, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FiPrinter } from '../../utils/icons';
import SelecionarQuestionarioModal from '../../components/SelecionarQuestionarioModal';

interface RelatorioDef {
  slug: 'auditoria' | 'planos-acao' | 'controle-interno';
  nome: string;
  descricao: string;
  disponivel: boolean;
  // Aviso mostrado no modal de seleção de questionário, após escolher — específico de
  // cada relatório (cada um organiza/ordena o conteúdo de um jeito diferente).
  aviso: string;
}

// Beta Teste: grid estático, sem filtro nem botão "Novo" — Auditoria e Planos de
// Ação já funcionam; Controle Interno fica como próximo passo do roadmap.
const RELATORIOS: RelatorioDef[] = [
  {
    slug: 'auditoria',
    nome: 'Auditoria',
    descricao: 'Resultado das auditorias, com não conformidades e comentários do auditor.',
    disponivel: true,
    aviso: 'O relatório será gerado com as constatações deste questionário, da mais grave para a menos grave.',
  },
  {
    slug: 'planos-acao',
    nome: 'Planos de Ação',
    descricao: 'Planos de Ação por Questionário.',
    disponivel: true,
    aviso: 'O relatório será gerado com os Planos de Ação registrados no questionário selecionado.',
  },
  {
    slug: 'controle-interno',
    nome: 'Controle Interno',
    descricao: 'Situação dos controles internos e respectivos níveis de conformidade.',
    disponivel: false,
    aviso: '',
  },
];

const RelatoriosListPage: React.FC = () => {
  const [modalRelatorio, setModalRelatorio] = useState<RelatorioDef | null>(null);
  const navigate = useNavigate();

  const handleSelecionarQuestionario = (questionarioId: number) => {
    if (!modalRelatorio) return;
    navigate(`/app/relatorios/${modalRelatorio.slug}/${questionarioId}`);
  };

  return (
    <Container fluid className="py-3 py-md-4">
      <div className="mb-3 mb-md-4">
        <h1 className="mb-0 fs-4 fs-md-3">Relatórios</h1>
        <p className="text-muted mb-0">Selecione o relatório que deseja imprimir.</p>
      </div>

      <Table hover responsive bordered className="mb-0">
        <thead className="table-light">
          <tr>
            <th>Relatório</th>
            <th>Descrição</th>
            <th style={{ width: 90 }} className="text-end">Ações</th>
          </tr>
        </thead>
        <tbody>
          {RELATORIOS.map(r => (
            <tr key={r.slug}>
              <td className="fw-medium">{r.nome}</td>
              <td className="text-muted">{r.descricao}</td>
              <td className="text-end">
                {r.disponivel ? (
                  <Button
                    className="btn-icon-ghost" size="sm"
                    onClick={() => setModalRelatorio(r)}
                    title="Imprimir"
                  >
                    <FiPrinter />
                  </Button>
                ) : (
                  <OverlayTrigger placement="top" overlay={<Tooltip>Em breve</Tooltip>}>
                    <span className="d-inline-block">
                      <Button className="btn-icon-ghost" size="sm" disabled style={{ pointerEvents: 'none' }}>
                        <FiPrinter />
                      </Button>
                    </span>
                  </OverlayTrigger>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      <SelecionarQuestionarioModal
        show={!!modalRelatorio}
        onHide={() => setModalRelatorio(null)}
        onConfirm={handleSelecionarQuestionario}
        titulo={`Imprimir Relatório de ${modalRelatorio?.nome || ''}`}
        aviso={modalRelatorio?.aviso || ''}
      />
    </Container>
  );
};

export default RelatoriosListPage;
